let confettiLoader = null

const loadConfetti = async () => {
  if (!confettiLoader) {
    confettiLoader = import('canvas-confetti').then(module => module.default)
  }
  return confettiLoader
}

const isElementInViewport = rect =>
  rect.bottom >= 0 &&
  rect.top <= window.innerHeight &&
  rect.right >= 0 &&
  rect.left <= window.innerWidth

/**
 * Fires a short confetti burst centered on a DOM element (party-popper style).
 * Lazy-loads canvas-confetti and no-ops on SSR / reduced motion / off-screen elements.
 */
export const burstAtElement = async (element, options = {}) => {
  if (typeof window === 'undefined' || !element) return

  const rect = element.getBoundingClientRect()
  if (rect.width === 0 && rect.height === 0) return
  if (!isElementInViewport(rect)) return

  const x = (rect.left + rect.width / 2) / window.innerWidth
  const y = (rect.top + rect.height / 2) / window.innerHeight

  const confetti = await loadConfetti()
  confetti({
    particleCount: 45,
    spread: 55,
    startVelocity: 28,
    gravity: 0.9,
    ticks: 100,
    origin: { x, y },
    disableForReducedMotion: true,
    ...options,
  })
}
